import { AccountsUpdateModal } from '@teuteuf-games/accounts-update-modal';
import { useContext } from 'react';
import UserContext from '../UserProvider';

const AccountsUpdateComponent = () => {
  const { showAccountsUpdateModal, userDetails } = useContext(UserContext);

  return (
    <AccountsUpdateModal show={showAccountsUpdateModal} loggedIn={userDetails.loggedIn} />
  );
};

export default AccountsUpdateComponent;